import { getStoreKeyByName } from "../Steps";

const nameStoreFormValue = getStoreKeyByName('contacts')

const defaultValue = {
  website: '',
  company: '',
  address: '',
  email: '',
  phone: '',
}

export const contactsFormState = set =>  ({
  isPrivateType: false,
  setPrivateType: value => set({ isPrivateType: value }),

  [nameStoreFormValue]:  defaultValue,
  resetContactsFormValue: () => set({ [nameStoreFormValue]: defaultValue  }),
  setContactsFormValue: value => set({ [nameStoreFormValue]: value}),
  changeContactsFormValue: (name, value) =>
    set(state => ({ [nameStoreFormValue]: {...state[nameStoreFormValue], [name]: value } })),
})